import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class IndicativosService {
    private urlModulo = `${environment.urlAPI}/indicativos`;

    constructor(private http: HttpClient) { }

    /**
     * Recupera a lista com as Auditorias Realizadas
     * @param codigo do usuario
     */
    public getDadosGraficoAuditor(codigo, ano): Promise<any> {
        const params = new HttpParams()
            .set('uid', codigo)
            .set('ano', ano);

        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-getdadosauditor`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter dados do gráfico do auditor:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera a lista com as Auditorias Agendadas
     * @param codigo do usuario
     */
    public getDadosGraficoCoordenador(codigoUsuario): Promise<any> {
        const params = new HttpParams().set('uid', codigoUsuario);

        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-getdadoscoordenador`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.retorno);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter dados do gráfico do coordenador:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera a lista com os Certificados Validos
     */
    public getDadosGraficoComite(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-getdadoscomite`)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.retorno);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter dados do gráfico do comitê:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera a lista com a Quantidade de auditorias a serem realizadas no ano
     */
    public getDadosGraficoSecretaria(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-getdadossecretaria`)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.retorno);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter dados do gráfico da secretaria:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera a lista com a Quantidade de auditorias (as que forem do CNPJ dele)
     */
    public getDadosIndicadoresFornecedor(uid): Promise<any> {
        const params = new HttpParams().set('uid', uid);

        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-getindicadoresfornecedor`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.retorno);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter indicadores do fornecedor:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera a lista com a Quantidade de Fornecedores em Desenvolvimento
     * Por Sistema Gestao
     */
    public getQuantidadeFornDesenvPorSG(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-getqtdfordesenvporsg`)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.retorno);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter quantidade de fornecedores em desenvolvimento por SG:');
                        reject(error);
                    }
                });
        });
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/indicativos.service.ts